/* eslint-disable no-empty-pattern */
/* eslint-disable no-underscore-dangle */
import translateError from '../../helpers/_modules/translateError';

const initState = {};
const initGetters = {};
const initMutations = {};

const initActions = {
	renderError({ dispatch }, error) {
		if (error.response !== undefined) {
			if (error.response.data.reason !== undefined) {
				dispatch('showCustomError', { error: error.response.data.reason, e: error.response.data });
				return Promise.reject(error.response.data);
			}
			if (error.response.status !== undefined) {
				dispatch('showError', { error: error.response.status });
			}
		} else if (error.reason !== undefined) {
			dispatch('showCustomError', { error: error.reason, e: error });
		} else {
			dispatch('notification', {
				type: 'error',
				title: 'Estas desconectado',
				text: 'No es posible acceder a la api de MC. Revisa tu conexión a internet. Si crees que se trata de un error avisanos.',
			});
		}
		return Promise.reject(error);
	},
	showCustomError({ }, { error, e }) {
		if (error === 'VALIDATION_ERROR') {
			if (e.data) {
				Object.keys(e.data).forEach((field) => {
					e.data[field].forEach((err) => {
						this.$message.error(`${field} ${err.message}`);
					});
				});
			}
		} else {
			const translated = translateError(error);
			if (translated.notify) this.$message.error(translated.text);
		}
	},
	showError({ }, { error }) {
		const messages = {
			504: 'Error 504: Se agoto el tiempo de conexión con la API',
			503: 'Error 503: Demasiadas peticiones por segundo',
			404: 'Error 404: Recurso no encontrado',
			400: 'Error 400: Solicitud no válida',
		};
		this.$message.error(messages[error] || `Error descatalogado. Código: ${error}`);
	},
	notification({ }, { type = 'error', title = '', text = '' }) {
		return this.$notification[type]({
			message: title,
			description: text,
		});
	},
};

export default {
	state: initState,
	getters: initGetters,
	actions: initActions,
	mutations: initMutations,
};
